import { MODAL_REQUEST } from '../modal/constants';

import { ADD_API_ERROR, REMOVE_API_ERROR } from './constants';

const INITIAL_STATE = null;

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_REQUEST: {
      return null;
    }
    case ADD_API_ERROR: {
      return formatApiError(action.payload);
    }
    case REMOVE_API_ERROR: {
      return null;
    }
    default:
      return state;
  }
};

export default reducer;

const formatApiError = (apiResponse) => {
  let output = '';
  if (apiResponse.response?.data?.errors) {
    output = apiResponse.response.data.errors.reduce((string, err) => {
      let newString = string;
      newString += `The "${err.field}" field errored due to "${err.message}" .`;
      return newString;
    }, '');
    output = `${apiResponse.response.data.message}. ${output}`;
  } else if (apiResponse.response?.data?.message) {
    output = `${apiResponse.response.data.message}. ${output}`;
  } else if (apiResponse.message === 'Network Error') {
    output =
      'Either the internet connection has been lost or the server is unavailable. Please try again later';
  } else {
    output = 'Server error: Something went wrong.';
  }
  return output;
};
